// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3BMF6","auth":"Auth_auth__23QaL","Input":"Auth_Input__2DFZ1"};